const TITLES =[
    'Fullstack Software Engineer.',
    'Poli Sci Major from Ohio State',
    'Former Ohio House Legislative Aide',
    'Tech Elevator Alumnus',
    'Video Game Enthusiast.',
    'Avid Student of History.',
    'Aspiring Recreational Hiker',
    'Proud Husband And Father.'
]
export default TITLES;